module.exports = __webpack_public_path__ + "static/img/loginBg1.dbeb8a1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Signup/loginBg1.jpeg
// module id = Virp
// module chunks = 37